module.exports = __webpack_public_path__ + "img/bot-icon.27249dc9.svg";